import Cookies from 'universal-cookie'
import placeholder from './img/no_image.svg'
import increase from './img/increase.svg'
import { InputDinamycPlaceholder } from '@lk-gtcom/ecomlab-components';
import { forwardRef, useRef, useState, useImperativeHandle, useEffect } from 'react'
// import { ARTICLE_TYPES } from '../ArticleElement'
import { useDebounce } from '../../../../hooks/useDebounce';
import useGeneralStore from '../../../../store/general';
import { useResponseHandler } from '../../../../common/auth';
import './ImgArticle.scss'
import { TextPage } from '../../../../components/TextPage/TextPage';
import { ButtonWithIcon } from '../../../../components/Buttons/ButtonWithIcon/ButtonWithIcon';
import UploadProgressBar from './UploadProgressBar/UploadProgressBar';// Импортируем новый компонент
import ImageViewer from '../../../../components/ImageViewer/ImageViewer';

const ImgArticle = forwardRef(({
    data,
    onChange,
    changeContent,
    setContentArr,
    id,
    setCurrentIndex,
    ind,
    setIsModal,
    before,
    setBeforeBlock,
    readonly = false,
}, ref) => {
    // Обработка ошибок
    const { handleStatusCode } = useResponseHandler();

    const [extension, setExtension] = useState("")
    const [error, setError] = useState(false)
    const [isOpen, setOpen] = useState(false)
    const fileInputRef = useRef()
    // const showPlaceholder = (data === undefined || data === '') && uploadedImage === undefined
    const cookies = new Cookies()
    const activeLang = localStorage.getItem('lang')
    const [objImg, setObjImg] = useState(null)
    const [altValue, setAltValue] = useState(data[0]?.properties?.alt || '')
    const selectedSpace = useGeneralStore((state) => state.selectedSpace);

    // Новые состояния для индикатора загрузки
    const [uploadStatus, setUploadStatus] = useState('idle'); // idle, loading, success, error
    const [uploadProgress, setUploadProgress] = useState(0);
    const xhrRef = useRef(null);
    const [currentFile, setCurrentFile] = useState(null);

    const translatePlaceholderOpen = () => {
        if (activeLang == 'ru') return 'Открыть изображение'
        if (activeLang == 'en') return 'Open image'
        if (activeLang == 'tr') return "Resmi büyüt"
        return 'Открыть изображение'
    }

    const translatePlaceholderSelected = () => {
        if (activeLang == 'ru') return 'Выберите изображение'
        if (activeLang == 'en') return 'Select an image'
        if (activeLang == 'tr') return "Bir resim seçin"
        return 'Выберите изображение'
    }

    useImperativeHandle(ref, () => ({
        error,
        // прикрутить открытие системного диалога с выбором изображения
        focus: () => { },
        data: objImg
    }), [objImg])

    const debounceChange = useDebounce(changeContent, 1000)

    useEffect(() => {
        debounceChange(id,
            [
                objImg
            ]
        )
        setContentArr((prev) => {
            return prev.map((el) => {
                if (el?.block_id == id) {
                    return {
                        ...el,
                        content: [
                            objImg
                        ]
                    }
                } else {
                    return el
                }
            })
        })
    }, [objImg]);

    // Форматирование размера файла
    const formatFileSize = (bytes) => {
        if (!bytes) return '';
        if (bytes < 1024) return bytes + ' B';
        if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
        return (bytes / (1024 * 1024)).toFixed(1) + ' MB';
    }

    const cancelUpload = () => {
        if (xhrRef.current) {
            xhrRef.current.abort();
            setUploadStatus('idle');
            setUploadProgress(0);
        }
    };

    const retryUpload = () => {
        if (currentFile) {
            setUploadStatus('loading');
            setUploadProgress(0);
            uploadWithXhr(currentFile);
        }
    };

    const handleSuccessClose = () => {
        setUploadStatus('idle');
        setUploadProgress(0);
        setCurrentFile(null);
    };

    const uploadWithXhr = (file) => {
        // Отменяем предыдущую загрузку, если она была
        if (xhrRef.current) {
            xhrRef.current.abort();
        }

        // Создаем новый XMLHttpRequest
        const xhr = new XMLHttpRequest();
        xhrRef.current = xhr;

        setUploadStatus('loading');
        setUploadProgress(0);

        const fd = new FormData()
        fd.append('file', file)  // имя поля строго 'file'
        const url = `https://file.ecomru.ru:4453/api/v1/file/upload`

        const token = cookies.get('auth')

        // Открываем соединение
        xhr.open('POST', url, true);

        // Устанавливаем заголовки
        xhr.setRequestHeader('space', selectedSpace?.value);
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.setRequestHeader('Cache-control', 'no-cache');
        xhr.setRequestHeader('Authorization', `Bearer ${token}`);

        // Отслеживаем прогресс загрузки
        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
                const percentComplete = Math.round((event.loaded / event.total) * 100);
                setUploadProgress(percentComplete);
            }
        };

        // Обработчик завершения загрузки
        xhr.onload = () => {
            if (xhr.status >= 200 && xhr.status < 300) {
                try {
                    const json = JSON.parse(xhr.responseText);
                    setUploadProgress(100);

                    if (json?.url) {
                        setObjImg({ value: json?.url, properties: { alt: altValue } })
                        setUploadStatus('success');

                        // Автоматически скрываем успех через 3 секунды
                        setTimeout(() => {
                            setUploadStatus('idle');
                            setUploadProgress(0);
                            setCurrentFile(null);
                        }, 3000);
                    }
                } catch (error) {
                    console.error('Error parsing response:', error);
                    setUploadStatus('error');
                }
            } else {
                if (handleStatusCode(xhr.status)) {
                    return;
                }
                console.error('Upload failed with status:', xhr.status);
                setUploadStatus('error');
            }
        };

        // Обработчик ошибки
        xhr.onerror = () => {
            console.error('Upload error');
            setUploadStatus('error');
        };

        // Обработчик прерывания
        xhr.onabort = () => {
            console.log('Upload cancelled');
            setUploadStatus('idle');
            setUploadProgress(0);
        };

        // Отправляем запрос
        xhr.send(fd);
    };

    const handleImageClick = (e) => {
        e.stopPropagation()

        if (readonly) {
            const html = document.querySelector('html')
            html.style = 'overflow: hidden'
            setOpen(!isOpen)
            return
        } else {
            if (fileInputRef.current) {
                fileInputRef.current.click()
            }
        }
    }

    const handleFileInput = (e) => {
        if (e.target.files.length === 0) {
            e.preventDefault()
            return
        }
        const file = e.target.files[0];
        setCurrentFile(file);

        const fileBase64Reader = new FileReader()
        fileBase64Reader.onload = () => {
            const re = /;base64,/
            const extensionAndBase64 = fileBase64Reader.result?.split(re)
            const onlyExtension = extensionAndBase64[0]?.split('image/')[1]
            setExtension(onlyExtension)
            uploadWithXhr(e.target.files[0])
        }
        fileBase64Reader.readAsDataURL(e.target.files[0])
        setError(false)
        onChange()
    }

    useEffect(() => {
        setObjImg({ value: data[0]?.value, properties: { alt: data[0]?.properties?.alt } })
    }, [])

    useEffect(() => {
        if (!isOpen) {
            if (typeof document !== 'undefined') {
                const html = document.querySelector('html')
                html.style = 'overflow: unset'
            }
        }
    }, [isOpen])

    useEffect(() => {
        setObjImg(prev => ({ ...prev, properties: { alt: altValue } }))
    }, [altValue]);

    // Очистка при размонтировании
    useEffect(() => {
        return () => {
            if (xhrRef.current) {
                xhrRef.current.abort();
            }
        };
    }, []);

    return (
        <div className='img-article__wrapper'
            onClick={(e) => {
                setCurrentIndex(ind)
                setBeforeBlock(before)
            }}
            onContextMenu={(e) => {
                if (!readonly) {
                    e.preventDefault()
                    setCurrentIndex(ind)
                    if (!isOpen) {
                        setIsModal(true)
                    }
                }
            }}
            tabIndex={0}
        >
            <ImageViewer
                isOpen={isOpen}
                images={objImg?.value}
                onClose={(e) => setOpen(false)}
            />

            <div className='img-article'>
                {!objImg?.value ?
                    <div className={'img-article__button'}>
                        <img
                            src={placeholder}
                            onError={e => {
                                e.target.src = placeholder
                                setError(true)
                            }}
                            className='img-article__icon'
                            extension={extension}
                            alt={altValue ? altValue : ''}
                        />

                        {!readonly && <div className='img-article__hidden-placeholder'>
                            <TextPage
                                style={{ fontSize: '20px' }}
                                text={translatePlaceholderSelected()}
                            />
                        </div>}

                        {!readonly && <input
                            name='uploadedImage'
                            ref={fileInputRef}
                            className='img-article__file-input'
                            type='file'
                            onChange={handleFileInput}
                            accept='image/png, image/jpeg'
                        />}
                    </div>
                    :
                    <div className={'img-article__box'}>
                        <img
                            src={objImg?.value ? objImg?.value : placeholder}
                            onError={e => {
                                e.target.src = placeholder
                                setError(true)
                            }}
                            className='img-article__img'
                            extension={extension}
                            alt={altValue ? altValue : ''}
                        />

                        <ButtonWithIcon
                            grey
                            icon={increase}
                            onClick={(e) => {
                                e.stopPropagation()
                                setOpen(true)
                            }}
                        />

                        {!readonly && <div className='img-article__hidden-placeholder'>
                            <TextPage
                                style={{ fontSize: '20px' }}
                                text={translatePlaceholderSelected()}
                            />
                        </div>}

                        {!readonly && <input
                            name='uploadedImage'
                            ref={fileInputRef}
                            className='img-article__file-input'
                            type='file'
                            onChange={handleFileInput}
                            accept='image/png, image/jpeg'
                        />}
                    </div>
                }

                {!readonly &&
                    <UploadProgressBar
                        status={uploadStatus}
                        progress={uploadProgress}
                        fileName={currentFile?.name}
                        fileSize={formatFileSize(currentFile?.size)}
                        uploadedSize={formatFileSize(((currentFile?.size || 0) * uploadProgress) / 100)}
                        speed={uploadStatus === 'loading' ? '1.2 MB/с' : ''}
                        onCancel={uploadStatus === 'loading' ? cancelUpload : handleSuccessClose}
                        onRetry={retryUpload}
                    />}

                {!readonly &&
                    <InputDinamycPlaceholder
                        placeholder='Значение alt'
                        size='s'
                        onChange={e => {
                            setAltValue(e)
                            debounceChange(id, [objImg])
                        }}
                        changeValue={altValue}
                        autoComplete={false}
                    />
                }
            </div>
        </div>
    )
})

export { ImgArticle }